import { render } from "./ApprovalPage.vue?vue&type=template&id=3f0fc73e&scoped=true"
import script from "./ApprovalPage.vue?vue&type=script&lang=js"
export * from "./ApprovalPage.vue?vue&type=script&lang=js"

import "./ApprovalPage.vue?vue&type=style&index=0&id=3f0fc73e&lang=css&scoped=true"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0fc73e"]])

export default __exports__